import React from 'react';
import {FormField, ImageUploader} from 'components';
import {useField} from 'helpers';
import css from './image.module.scss';

export function Image({ name }) {
  const [ { value }, , { setValue } ] = useField(name);
  const hasImage = Boolean(value && (value.contentPlain || value.url));
  return (
    <FormField label="Image" className={['clickable', css.field]} value={hasImage} clear={() => setValue(null)}>
      { hasImage &&
        <img className={css.image} src={value.url || value.contentPlain} />
      }
      <ImageUploader onComplete={setValue} />
    </FormField>
  );
}
